exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".our-product{color:#fff;background-color:#7eaeda}.our-product h1{color:#fff;margin-bottom:20px}.our-product p{text-align:center}mat-icon{margin-right:15px;width:30px;height:30px;color:#448aff}.single-about{padding:20px}.single-about h4{overflow:hidden;font-size:20px;margin-bottom:20px}", ""]);

// exports
